export default __webpack_public_path__ + "static/media/avatar-child-boy.16b08be6.png";